<app-dialog
  [headerLabel]="'DIALOG.TURN_ON_PAYMENTS.TITLE' | translate"
  [dialogType]="dialogType"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionText]="'DIALOG.TURN_ON_PAYMENTS.CTA' | translate"
  [primaryActionTapped]="primaryActionTapped"
  [secondaryActionText]="'ACTION.NO_THANKS' | translate"
  [secondaryActionTapped]="secondaryActionTapped"
  (onPrimaryAction)="onTurnOnPayments.emit()"
>
  <div id="turn-on-payments-dialog">
    <p class="info">
      {{ 'DIALOG.TURN_ON_PAYMENTS.INFO' | translate }}
    </p>

    <p *ngIf="feesDescription" class="fees-description">
      {{ feesDescription }}
    </p>
  </div>
</app-dialog>
